export interface CreatePreSignedUrlRequest {
  original_name: string;
}

export interface CreatePreSignedUrlResponse {
  upload_url: string;
  file_path: string;
  id: string;
}

export enum FileType {
  ORGANIZATION_LOGO = "organization-logo",
}

export enum FileExtension {
  JPG = "jpg",
  PNG = "png",
  JPEG = "jpeg",
}

export const getFileExtension = (filename: string): FileExtension | null => {
  const extension = filename.split(".").pop()?.toLowerCase();
  if (
    extension &&
    Object.values(FileExtension).includes(extension as FileExtension)
  ) {
    return extension as FileExtension;
  }
  return null;
};
